var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{attrs:{"accordion":"","multiple":"","hover":"","focusable":""}},[_vm._l((_vm.oldStudies),function(study){return _c('StudyItem',{key:study.id,attrs:{"study":study}})}),(_vm.oldStudies.length === 0)?_c('div',[_c('br'),_c('span',{staticClass:"text-subtitle-1"},[_vm._v("No History for the current patient")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }